import { render } from "./ActivitiesListingMassModifyOwner.vue?vue&type=template&id=2a05b720"
import script from "./ActivitiesListingMassModifyOwner.vue?vue&type=script&lang=js"
export * from "./ActivitiesListingMassModifyOwner.vue?vue&type=script&lang=js"

import "./ActivitiesListingMassModifyOwner.vue?vue&type=style&index=0&id=2a05b720&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__